

















import Component from "vue-class-component";
import ProgressSpinner from "@/general/component/spinner/ProgressSpinner.vue";
import { Mixins } from "vue-property-decorator";
import { Page } from '@/layout/mixin/Page';


@Component({
  components: { ProgressSpinner }
})
export default class PageLayout extends Mixins(Page) {}
